module.exports = __webpack_public_path__ + "assets/09d7e95d8828efc64ec054561d3d217b.png";